import React, { Fragment } from "react"
import ReactDOM from "react-dom"
import { Box, List, ListItem, Typography } from "@material-ui/core"
import { makeStyles } from "@material-ui/core/styles"
const useStyles = makeStyles(theme => ({
  ullist: {
    paddingTop: 0,
    paddingBottom: 0,
  },
  listItem: {
    paddingLeft: 0,
    paddingRight: 0,
  },
}))
const EventItem = ({ data }) => {
  const endDate =
    data["startDate"]["string"] !== data["endDate"]["string"] ? true : false
  const classes = useStyles()
  return (
    <Fragment>
      <ListItem className="cal-items">
        <List className={classes.ullist + " " + "table"}>
          <ListItem>
            <Typography variant="h3" className="event-not-clickable">
              <Box component="span">{data["title"]}</Box>
            </Typography>
          </ListItem>
          <ListItem>
            <Box component="div" className="l-period">
              <Box component="span" className="date">
                {data["startDate"]["day"]}
              </Box>
              <Box component="div" className="l-period__date">
                <Box component="span" className="month">
                  {data["startDate"]["month"]}
                </Box>
                <Box component="span" className="year">
                  {data["startDate"]["year"]}
                </Box>
              </Box>
              {endDate && (
                <Fragment>
                  <Box component="span" className="hypen">
                    -
                  </Box>
                  <Box component="span" className="date">
                    {data["endDate"]["day"]}
                  </Box>
                  <Box component="div" className="l-period__date">
                    <Box component="span" className="month">
                      {data["endDate"]["month"]}
                    </Box>
                    <Box component="span" className="year">
                      {data["endDate"]["year"]}
                    </Box>
                  </Box>
                </Fragment>
              )}
            </Box>
          </ListItem>
        </List>
      </ListItem>
    </Fragment>
  )
}

export default EventItem
